import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';

import ListPill from './ListPill';
import NewFloatingTaskWidget from './NewFloatingTaskWidget';
import Spinner from './Spinner';

require.ensure([], () => {  
    require('./TaskListWidget.less');
});

class TaskListWidget extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        let storedTreeView = localStorage.getItem("treeView");

        this.state = {
            otherTasks: [],
            favoriteTasks: [],
            mostFrequentlyUsedTasks: [],
            recentlyAssignedTasks: [],
            floatingTasks: [],
            pms: [],
            filterByTaskAndProjectName: null,
            treeView: storedTreeView !== null && storedTreeView !== undefined ? storedTreeView === "true" : false,
            projects: {},
            projectOpen: [],
            showNewFloatingWidget: false,
            expanded: false
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        let projects = {};
        let favoriteTasks = [];
        let mostFrequentlyUsedTasks = [];
        let recentlyAssignedTasks = [];
        let otherTasks = [];
        let existingAliases = [];

        for (let i = 0; i < nextProps.favoriteTasks.length; i++) {
            let task = nextProps.favoriteTasks[i];
            if (task.alias) {
                existingAliases.push(task.alias);
            }

            if (nextProps.date) {
                /*if (nextProps.date.clone().format("YYYY-MM-DD") < moment(task.assignedOn, "YYYY-MM-DD").subtract(30, "days").format("YYYY-MM-DD"))
                    continue; */

                if (task.projectStartDate && nextProps.date.clone().format("YYYY-MM-DD") < task.projectStartDate)
                    continue;

                if (task.projectEndDate && nextProps.date.clone().format("YYYY-MM-DD") > task.projectEndDate)
                    continue;
            }

            favoriteTasks.push(task);

            let projectName = nextProps.favoriteTasks[i].projectName;

            if (!projects[projectName]) {
                let project = {
                    name: projectName,
                    color: nextProps.favoriteTasks[i].color,
                    tasks: []
                };
                project.tasks.push(nextProps.favoriteTasks[i]);
                projects[projectName] = project;
            } else {
                projects[projectName].tasks.push(nextProps.favoriteTasks[i]);
            }
        }

        for (let i = 0; i < nextProps.mostFrequentlyUsedTasks.length; i++) {
            let task = nextProps.mostFrequentlyUsedTasks[i];
            if (task.alias) {
                existingAliases.push(task.alias);
            }

            if (nextProps.date) {
                /*if (nextProps.date.clone().format("YYYY-MM-DD") < moment(task.assignedOn, "YYYY-MM-DD").subtract(30, "days").format("YYYY-MM-DD"))
                    continue;*/

                if (task.projectStartDate && nextProps.date.clone().format("YYYY-MM-DD") < task.projectStartDate)
                    continue;

                if (task.projectEndDate && nextProps.date.clone().format("YYYY-MM-DD") > task.projectEndDate)
                    continue;
            }

            mostFrequentlyUsedTasks.push(task);

            let projectName = nextProps.mostFrequentlyUsedTasks[i].projectName;

            if (!projects[projectName]) {
                let project = {
                    name: projectName,
                    color: nextProps.mostFrequentlyUsedTasks[i].color,
                    tasks: []
                };
                project.tasks.push(nextProps.mostFrequentlyUsedTasks[i]);
                projects[projectName] = project;
            } else {
                projects[projectName].tasks.push(nextProps.mostFrequentlyUsedTasks[i]);
            }
        }

        for (let i = 0; i < nextProps.otherTasks.length; i++) {
            let task = nextProps.otherTasks[i];
            if (task.alias) {
                existingAliases.push(task.alias);
            }

            if (nextProps.date) {
                /*if (nextProps.date.clone().format("YYYY-MM-DD") < moment(task.assignedOn, "YYYY-MM-DD").subtract(30, "days").format("YYYY-MM-DD"))
                    continue;*/

                if (task.projectStartDate && nextProps.date.clone().format("YYYY-MM-DD") < task.projectStartDate)
                    continue;

                if (task.projectEndDate && nextProps.date.clone().format("YYYY-MM-DD") > task.projectEndDate)
                    continue;
            }

            otherTasks.push(task);

            let projectName = nextProps.otherTasks[i].projectName;

            if (!projects[projectName]) {
                let project = {
                    name: projectName,
                    color: nextProps.otherTasks[i].color,
                    tasks: []
                };
                project.tasks.push(nextProps.otherTasks[i]);
                projects[projectName] = project;
            } else {
                projects[projectName].tasks.push(nextProps.otherTasks[i]);
            }
        }

        for (let i = 0; i < nextProps.recentlyAssignedTasks.length; i++) {
            let task = nextProps.recentlyAssignedTasks[i];
            if (task.alias) {
                existingAliases.push(task.alias);
            }

            if (nextProps.date) {
                /*if (nextProps.date.clone().format("YYYY-MM-DD") < moment(task.assignedOn, "YYYY-MM-DD").subtract(30, "days").format("YYYY-MM-DD"))
                    continue;*/

                if (task.projectStartDate && nextProps.date.clone().format("YYYY-MM-DD") < task.projectStartDate)
                    continue;

                if (task.projectEndDate && nextProps.date.clone().format("YYYY-MM-DD") > task.projectEndDate)
                    continue;
            }

            recentlyAssignedTasks.push(task);

            let projectName = nextProps.recentlyAssignedTasks[i].projectName;

            if (!projects[projectName]) {
                let project = {
                    name: projectName,
                    color: nextProps.recentlyAssignedTasks[i].color,
                    tasks: []
                };
                project.tasks.push(nextProps.recentlyAssignedTasks[i]);
                projects[projectName] = project;
            } else {
                projects[projectName].tasks.push(nextProps.recentlyAssignedTasks[i]);
            }
        }

        for (let i = 0; i < nextProps.floatingTasks.length; ++i) {
            let task = nextProps.floatingTasks[i];
            if (task.alias) {
                existingAliases.push(task.alias);
            }
            let projectName = "Floating Tasks";

            if (!projects[projectName]) {
                let project = {
                    name: projectName,
                    color: "#ddd",
                    tasks: []
                };
                project.tasks.push(nextProps.floatingTasks[i]);
                projects[projectName] = project;
            } else {
                projects[projectName].tasks.push(nextProps.floatingTasks[i]);
            }
        }

        this.setState({
            otherTasks: otherTasks,
            favoriteTasks: favoriteTasks,
            mostFrequentlyUsedTasks: mostFrequentlyUsedTasks,
            recentlyAssignedTasks: recentlyAssignedTasks,
            floatingTasks: nextProps.floatingTasks,
            pms: nextProps.pms,
            projects: projects,
            loading: nextProps.loading,
            existingAliases: existingAliases
        });
    }

    // EVENT HANDLERS

    handleAddFloatingTask = () => {
        this.props.handleAddFloatingTask();
    }

    handleHideModal = () => {
        this.setState({
            showNewFloatingWidget: false
        });
    }

    handleProjectClick = (key) => {
        this.state.projectOpen[key] = !this.state.projectOpen[key];
        this.forceUpdate();
    }

    handleShowModal = () => {
        this.setState({
            showNewFloatingWidget: true
        });
    }

    handleTaskAndProjectFilter = (changeEvent) => {
        this.setState({
            filterByTaskAndProjectName: changeEvent.target.value.trim().toLowerCase()
        });
    }

    handleToggle = () => {
        this.setState({
            expanded: !this.state.expanded
        });
    }

    handleViewSwitch = () => {
        this.setState({
            treeView: !this.state.treeView
        }, () => {
            localStorage.setItem("treeView", this.state.treeView);
        });
    }

    // OTHER METHODS

    clearFilter = () => {
        this.setState({
            filterByTaskAndProjectName: ""
        });
        ReactDOM.findDOMNode(this.refs.filterField).value = '';
    }

    renderUserTaskListToPanel (key, separatorText, list) {
        if (list === undefined || list.length === 0)
            return null;
        
        return list.map((task, i) => {
            if (this.state.filterByTaskAndProjectName) {
                let words = this.state.filterByTaskAndProjectName.split(' ');
                let projectAndTaskName = (task.name + task.projectName).toLowerCase();

                if (task.alias) {
                    projectAndTaskName += task.alias.toLowerCase();
                }

                for (let j = 0; j < words.length; ++j) {
                    if (projectAndTaskName.indexOf(words[j]) === -1)
                        return null;
                }
            }

            return ( <ListPill
                        createTimer={this.props.createTimer}
                        createLogEntry={this.props.createLogEntry}
                        date={this.props.date}
                        existingAliases={this.state.existingAliases}
                        id={task.name + key*(i+1)}
                        infoUserTask={this.props.infoUserTask}
                        key={task.name + key*(i+1)}
                        pmUsers={this.state.pms}
                        setFillTaskForLogEntry={this.props.setFillTaskForLogEntry}
                        task={task}
                        timesheet={this.props.timesheet}
                        />
                        );
        });
    }

    // RENDER METHOD

    render = () => {
        if (this.state.loading)
            return (
                    <div style={this.state.expanded ? {left : 0} : {}} className="panel panel-aside task-list">
                        <br/>
                        <Spinner />
                    </div>
            );
        
        if (this.state.treeView) {
            return (
                <div style={this.state.expanded ? {left : 0} : {}} className="panel panel-aside task-list">
                    <a onClick={this.handleToggle} className="panel-aside-handle" style={{zIndex: 0}}><span className={this.state.expanded ? "md-chevron-left md-2x" : "md-chevron-right md-2x"}></span></a>
                    {
                        this.state.showNewFloatingWidget ? <NewFloatingTaskWidget onRequestHide={this.handleHideModal} pmUsers={this.state.pms} user={this.props.currentUser}/> : null
                    }
                    <div className="scrollable-div">
                        <div className="panel-heading">
                            <div className="panel-title">
                                <h4>My Tasks <a title="Switch to normal Tashi view" className="icon-btn pull-right"><span><span className="md-swap-horiz" onClick={this.handleViewSwitch}/></span></a></h4>
                            </div>
                        </div>
                        <div className="panel-filter">
                            <div className="form-group">
                                <label>Filter:</label>
                                <input ref="filterField" type="text" className="form-control" placeholder="Project or Task Name" onChange={this.handleTaskAndProjectFilter}/>
                                <a style={{"cursor" : "pointer", paddingRight : "10px", paddingTop : "5px"}} onClick={this.clearFilter} className="filter-clear"><span><span className="md-clear"></span></span></a>
                            </div>
                        </div>
                        <div className="panel-body tasks">
                            <hr/>
                            <ul>
                            {
                                Object.keys(this.state.projects).map((name, key) => {
                                    let project = this.state.projects[name];

                                    // don't show the project if it doesn't have tasks to show
                                    if (project.tasks.length == 0)
                                        return null;

                                    // see if the project will have at least 1 task after filtering
                                    // and only then show it
                                    if (this.state.filterByTaskAndProjectName) {
                                        let show = false;

                                        for (let i = 0; i < project.tasks.length; ++i) {
                                            let words = this.state.filterByTaskAndProjectName.split(' ');
                                            let projectAndTaskName = (project.tasks[i].name + project.tasks[i].projectName).toLowerCase();

                                            for (let j = 0; j < words.length; ++j) {
                                                if (projectAndTaskName.indexOf(words[j]) !== -1) {
                                                    show = true;
                                                    break;
                                                }
                                            }

                                            if (show) break;
                                        }

                                        if (!show) return null;
                                    }

                                    return (
                                        <div>
                                            <div className="project">
                                                <div style={{marginBottom : "0px"}} className="panel panel-default panel-pmproject" >
                                                    <div  className="panel-heading" role="tab" id="headingThree-outer">
                                                        <h4 className="panel-title" style={{backgroundColor : project.color}}>
                                                        <a style={{"cursor" : "pointer"}} onClick={this.handleProjectClick.bind(this,key)} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                                                            {name}
                                                            <span className="acc"><span className={this.state.projectOpen[key] ? "md-expand-more": "md-chevron-right"}></span></span>
                                                        </a>
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                            { this.state.projectOpen[key] ? this.renderUserTaskListToPanel(1000*key, name, project.tasks) : "" }
                                            <div style={{"height" : "8px"}}/>
                                        </div>
                                    );
                                })
                            }
                            </ul>
                            <div style={{"height" : "8px"}}/>
                            <button onClick={this.handleShowModal} title="Create new floating task" className="btn1 btn1-default btn1-centered" type="button">New Floating Task</button>
                         </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div style={this.state.expanded ? {"left" : 0} : {}} className="panel panel-aside task-list">
                    <a onClick={this.handleToggle} style={{zIndex: 0}} className="panel-aside-handle"><span className={this.state.expanded ? "md-chevron-left md-2x" : "md-chevron-right md-2x"}></span></a>
                    {
                        this.state.showNewFloatingWidget ? <NewFloatingTaskWidget pmUsers={this.state.pms} onRequestHide={this.handleHideModal} user={this.props.currentUser}/> : null
                    }
                    <div className="scrollable-div">
                        <div className="panel-heading">
                            <div className="panel-title">
                                <h4>My Tasks <a title="Switch to tree view" className="icon-btn pull-right"><span><span className="md-swap-horiz" onClick={this.handleViewSwitch}/></span></a></h4>
                            </div>
                        </div>
                        <div className="panel-filter">
                            <div className="form-group">
                                <label>Filter:</label>
                                <input ref="filterField" type="text" className="form-control" placeholder="Project or Task Name" onChange={this.handleTaskAndProjectFilter}/>
                                <a style={{"cursor" : "pointer", paddingRight : "10px", paddingTop : "5px"}} onClick={this.clearFilter} className="filter-clear"><span><span className="md-clear"></span></span></a>
                            </div>
                        </div>
                        <div className="panel-body tasks">
                            <hr className="favorite"/>
                            <ul>
                                { this.renderUserTaskListToPanel(1, "Favorite" , this.state.favoriteTasks) }
                            </ul>

                            <br/><hr className="floating"/>
                            <ul>
                                { this.renderUserTaskListToPanel(100, "Floating", this.state.floatingTasks) }
                            </ul>

                            <br/>
                            <button onClick={this.handleShowModal} title="Create a new floating task" className="btn1 btn1-default btn1-centered" type="button">New Floating Task</button>
                            <br/><hr className="other" />
                            <ul>
                                { this.renderUserTaskListToPanel(1000, "Most Frequently Used", this.state.mostFrequentlyUsedTasks) }   
                                { this.renderUserTaskListToPanel(10000, "Recently Assigned", this.state.recentlyAssignedTasks) } 
                                { this.renderUserTaskListToPanel(100000, "Other", this.state.otherTasks) }
                            </ul>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

TaskListWidget.propTypes = {
    createLogEntry: PropTypes.func,
    createTimer: PropTypes.func,
    currentUser: PropTypes.object,
    date: PropTypes.object,
    favoriteTasks: PropTypes.array,
    floatingTasks: PropTypes.array,
    handleAddFloatingTask: PropTypes.func,
    infoUserTask: PropTypes.object,
    loading: PropTypes.bool,
    mostFrequentlyUsedTasks: PropTypes.array,
    otherTasks: PropTypes.array,
    pms: PropTypes.array,
    recentlyAssignedTasks: PropTypes.array,
    setFillTaskForLogEntry: PropTypes.func,
    timesheet: PropTypes.object
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapDispatchToProps
)(TaskListWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/TaskListWidget.js
 **/